module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/fiscal-sales-visualizer/fiscal-sales-visualizer.html
// module id = 1217
// module chunks = 0